import { Button, HStack } from "@chakra-ui/react";
import { DataTable, NavBar } from "@components/ui-kit";
import { Pagination } from "@components/ui-kit/table/pagination";
import { Trans, t } from "@lingui/macro";
import type { ProjectsWhereColumn } from "@src/__generated__/urql-graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { FiltersPanel } from "@src/utils/components/filters/components/filters-panel";
import { Can } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { useContext } from "react";
import { PageBudgetExceededCtx } from "./PageBudgetExceeded";
import { Quickfilter } from "./StoreBudgetExceeded";
import { TableBudgetExceeded } from "./table/TableBudgetExceeded";

export const CardListBudgetExceeded = observer(
  function CardListBudgetExceeded() {
    const router = useRouter();
    const store = useContext(PageBudgetExceededCtx);

    return (
      <div data-testid="card-list-projects">
        <DataTable>
          <DataTable.NavBar>
            <HStack justifyContent="space-between">
              <NavBar>
                <NavBar.Item
                  active={!store.activeQuickFilter?.value?.[0]}
                  onClick={() => {
                    store.activeQuickFilter?.clear();
                  }}
                >
                  <Trans>All</Trans>
                </NavBar.Item>

                <NavBar.Item
                  active={
                    store.activeQuickFilter?.value?.[0] ===
                    Quickfilter.AllActive
                  }
                  onClick={() => {
                    store.activeQuickFilter?.setValue(Quickfilter.AllActive);
                  }}
                >
                  <Trans>All active</Trans>
                </NavBar.Item>

                <NavBar.Item
                  active={
                    store.activeQuickFilter?.value?.[0] === Quickfilter.MyActive
                  }
                  onClick={() => {
                    store.activeQuickFilter?.setValue(Quickfilter.MyActive);
                  }}
                >
                  <Trans>My active</Trans>
                </NavBar.Item>

                <NavBar.Item
                  active={
                    store.activeQuickFilter?.value?.[0] === Quickfilter.Finished
                  }
                  onClick={() => {
                    store.activeQuickFilter?.setValue(Quickfilter.Finished);
                  }}
                >
                  <Trans>Finished</Trans>
                </NavBar.Item>

                <NavBar.Item
                  active={
                    store.activeQuickFilter?.value?.[0] === Quickfilter.Archived
                  }
                  onClick={() => {
                    store.activeQuickFilter?.setValue(Quickfilter.Archived);
                  }}
                >
                  <Trans>Archived</Trans>
                </NavBar.Item>
              </NavBar>

              <Can
                do={[
                  "project_create_all",
                  "project_create_own",
                  "project_create_team",
                ]}
              >
                <Button
                  ml="auto"
                  leftIcon={<Icon name="plus" />}
                  onClick={() => router.push(`/projects/create`)}
                >
                  {t`New Project`}
                </Button>
              </Can>
            </HStack>
          </DataTable.NavBar>
          <DataTable.Filter>
            <div data-testid="filters">
              <FiltersPanel<ProjectsWhereColumn>
                filters={store.where}
                searchPlaceholder={t`Search by title, code, brand`}
                searchDefaultValue={store.searchTerm}
                onSearch={(val) => {
                  store.setSearchTerm(val);
                  store.pagination.resetPage();
                }}
              />
            </div>
          </DataTable.Filter>

          <TableBudgetExceeded />
          <Pagination store={store.pagination} />
        </DataTable>
      </div>
    );
  },
);
